import { LoginWrapper } from './login.styles';
import useMsal from '../../auth/useMsal';
import useExternalMsal from '../../auth/useExternalMsal';

// Mirrors ArmadaPortal's login choice: Odfjell staff sign in with the internal
// Azure AD tenant, everyone else (existing or new customers) goes through the
// Entra External ID (CIAM) hosted flow, which itself handles both sign-in and
// self-service sign-up.
const Login = () => {
    const { loginAzAd } = useMsal();
    const { loginExternal } = useExternalMsal();

    return (
        <LoginWrapper>
            <h1>Welcome</h1>
            <div>
                <p>Please login or sign up for access to OrcaWeb</p>
                <div className="contact-details">
                    For questions, please contact
                    <a href="mailto:fleetperformance@odfjell.com"> fleetperformance@odfjell.com</a>
                </div>
                <button onClick={loginAzAd}>Odfjell employee</button>
                <button onClick={loginExternal}>Other</button>
            </div>
        </LoginWrapper>
    );
};

export default Login;
